import MultiselectField from '@/components/ui/form-inputs/MultiselectField';
import { USER_FORM_KEY } from '@/shared/constants/form-keys';
import { Checkbox, MenuItem } from '@mui/material';
import { ChangeEvent, FunctionComponent, ReactElement, useMemo } from 'react';
import { CommonSiteSelectProps } from './types';

const SiteMultiSelect: FunctionComponent<CommonSiteSelectProps> = ({
	formModel,
	updateFormModel,
	sites,
	disabled = false,
}): ReactElement => {
	const onSitesChange = (event: ChangeEvent<HTMLInputElement>) => {
		const value = event.target.value as unknown as string[];
		if (value[value.length - 1] === 'select_all') {
			const { sites: selected } = formModel;
			updateFormModel({
				...formModel,
				sites: selected?.length === sites?.length ? [] : sites?.map((site) => site.id),
			});
			return;
		}
		updateFormModel({ ...formModel, sites: value });
	};

	const selectedAllSites = useMemo(
		() => !!sites?.length && sites.length > 0 && formModel.sites?.length === sites.length,
		[sites, formModel]
	);

	return (
		<MultiselectField
			id="sites"
			name="sites"
			label="Sites"
			formKey={USER_FORM_KEY}
			value={formModel.sites}
			onChange={onSitesChange}
			renderValue={(selected) =>
				selected.map((id) => sites?.find((site) => site.id === id)?.name).join(', ')
			}
			disabled={disabled}
		>
			<MenuItem value="select_all">
				<Checkbox checked={selectedAllSites} />
				Select All
			</MenuItem>
			{sites?.map((site) => (
				<MenuItem key={site.id} value={site.id}>
					<Checkbox checked={formModel.sites?.includes(site.id)} />
					{site.name}
				</MenuItem>
			))}
		</MultiselectField>
	);
};

export default SiteMultiSelect;
